import { createFileRoute } from "@tanstack/react-router";
import { AiStudioChat } from "@/components/AiStudio";

function RouteComponent() {
  const { chatId } = Route.useParams();
  return <AiStudioChat key={chatId} chatId={chatId} />;
}

export const Route = createFileRoute("/_authenticated/ai-studio/$chatId")({
  component: RouteComponent,
  staticData: { page: "university" },
});
